var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CContainer',[_c('TheAsideBar',{attrs:{"componentName":_vm.$attrs.AsidebarComponente}}),_c('CWrapper',{staticClass:"justify-content-between"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }